import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { BarcodeScannerScreen } from "./screens";
import { BarcodeSettingsScreen } from "./screens/BarcodeSettingsScreen";
import { ProductScannedPartialScreen } from "./screens/ProductScannedPartialScreen";
import { RetailerOnlyScannedPartialScreen } from "./screens/RetailerOnlyScannedPartialScreen";

export interface BarcodeScannerRootScreenProps {}

export function BarcodeScannerRootScreen(props: BarcodeScannerRootScreenProps) {
  const Stack = createStackHeaderNavigator();

  return (
    <Stack.Navigator
      detachInactiveScreens
      screenOptions={{
        headerShown: false,
        headerTitleAlign: "center",
        cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
      }}
    >
      <Stack.Screen
        name="BarcodeScannerScreen"
        component={BarcodeScannerScreen}
        options={{
          title: "Scanner",
        }}
      />
      <Stack.Group
        screenOptions={{
          presentation: "modal",
          cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
        }}
      >
        <Stack.Screen
          name="BarcodeSettingsScreen"
          options={{
            title: "Scanner Settings",
            headerShown: true,
            animationEnabled: true,
            headerLeft: () => <ModalCloseButton type="Close" iconOnly />,
          }}
          component={BarcodeSettingsScreen}
        />
      </Stack.Group>
      <Stack.Group
        screenOptions={{
          presentation: "transparentModal",
          cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
        }}
      >
        <Stack.Screen
          name="ProductScannedPartialScreen"
          options={{
            headerShown: false,
            animationEnabled: true,
          }}
          component={ProductScannedPartialScreen}
        />
        <Stack.Screen
          name="RetailerOnlyScannedPartialScreen"
          options={{
            headerShown: false,
            animationEnabled: true,
          }}
          component={RetailerOnlyScannedPartialScreen}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
}
